import { render } from "./FootBar.vue?vue&type=template&id=06ff3327&scoped=true"
import script from "./FootBar.vue?vue&type=script&lang=js"
export * from "./FootBar.vue?vue&type=script&lang=js"

import "./FootBar.vue?vue&type=style&index=0&id=06ff3327&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\ASRHAVELI\\attendance\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ff3327"]])

export default __exports__